/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareAdmissionDemographicsUpdateResponse
 */
export interface MatrixCareAdmissionDemographicsUpdateResponse {
    /**
     * True when MatrixCare returned Success on the save.
     * @type {boolean}
     * @memberof MatrixCareAdmissionDemographicsUpdateResponse
     */
    saved: boolean;
    /**
     * MatrixCare's own SuccessMessage, when it sends one.
     * @type {string}
     * @memberof MatrixCareAdmissionDemographicsUpdateResponse
     */
    success_message?: string | null;
}

/**
 * Check if a given object implements the MatrixCareAdmissionDemographicsUpdateResponse interface.
 */
export function instanceOfMatrixCareAdmissionDemographicsUpdateResponse(value: object): value is MatrixCareAdmissionDemographicsUpdateResponse {
    if (!('saved' in value) || value['saved'] === undefined) return false;
    return true;
}

export function MatrixCareAdmissionDemographicsUpdateResponseFromJSON(json: any): MatrixCareAdmissionDemographicsUpdateResponse {
    return MatrixCareAdmissionDemographicsUpdateResponseFromJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareAdmissionDemographicsUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'saved': json['saved'],
        'success_message': json['success_message'] == null ? undefined : json['success_message'],
    };
}

export function MatrixCareAdmissionDemographicsUpdateResponseToJSON(json: any): MatrixCareAdmissionDemographicsUpdateResponse {
    return MatrixCareAdmissionDemographicsUpdateResponseToJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsUpdateResponseToJSONTyped(value?: MatrixCareAdmissionDemographicsUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'saved': value['saved'],
        'success_message': value['success_message'],
    };
}

